import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Paper, Button } from "@mui/material";
import { Lock } from "@mui/icons-material";
import useAuth from "../../hooks/useAuth";
import { hasPermission } from "../../utils/permissionUtils";

const PermissionGuard = ({
  children,
  requiredPermission,
  fallbackComponent = null,
}) => {
  const { user } = useAuth();
  const navigate = useNavigate();

  // Check if user has the required permission (includes client bypass logic)
  const userHasPermission = hasPermission(requiredPermission);

  if (!userHasPermission) {
    // If a custom fallback component is provided, render it
    if (fallbackComponent) {
      return fallbackComponent;
    }

    // Default access denied component
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "60vh",
          padding: 3,
        }}
      >
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            textAlign: "center",
            maxWidth: 400,
            backgroundColor: "background.paper",
          }}
        >
          <Lock
            sx={{
              fontSize: 64,
              color: "error.main",
              marginBottom: 2,
            }}
          />
          <Typography variant="h5" component="h1" gutterBottom>
            Access Denied
          </Typography>
          <Typography variant="body1" color="text.secondary" paragraph>
            You don't have permission to access this page. Please contact your
            administrator if you believe this is an error.
          </Typography>
          <Typography variant="body2" color="text.secondary" paragraph>
            Required permission: <strong>{requiredPermission}</strong>
          </Typography>
          <Button
            variant="contained"
            onClick={() => navigate(-1)}
            sx={{ marginTop: 2 }}
          >
            Go Back
          </Button>
        </Paper>
      </Box>
    );
  }

  // User has permission, render the protected component
  return children;
};

export default PermissionGuard;
